import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, tap } from "rxjs";
import { ResponseInfo } from "../../../services/auth/model/response-info.model";
import { AuthDiscoveryResponse } from "../model/auth-discovery.model";
import { environment } from "../../../../../environments/environment";
import { ErrorHandlerService } from "../../../services/error-handler/error-handler.service";

@Injectable({
	providedIn: "root"
})
export class LoginService {
	private readonly errorHandlerService = inject(ErrorHandlerService);

	private readonly http = inject(HttpClient);

	private readonly doLoginSsoURL = environment.apiAuthUrl + "/login-sso?code=";
	private readonly discoveryURL = environment.apiGatewayUrl + "/public/auth/discovery";

	discover(username: string): Observable<AuthDiscoveryResponse> {
		return this.http.post<AuthDiscoveryResponse>(this.discoveryURL, { username }).pipe(
			tap({
				error: error =>
					this.errorHandlerService.showError(error, "Failed to start login! Please try again")
			})
		);
	}

	doLoginSso(code: string): Observable<ResponseInfo> {
		return this.http.get<ResponseInfo>(this.doLoginSsoURL + code).pipe(
			tap({
				error: error => this.errorHandlerService.showError(error, "Failed to login with SSO")
			})
		);
	}
}
